import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const MapFlyToProveedor = ({ lat, lng }) => {
    const map = useMap();

    useEffect(() => {
        if (lat && lng) {
            map.flyTo([lat, lng], 15, {
                animate: true,
                duration: 1.5,
            });
        }
    }, [lat, lng, map]);

    return null;
};

export default MapFlyToProveedor;
